import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetWithDrawDepositGraphResponse,
	GetWithDrawDepositGraphRequest,
} from '@/modules/dashboard/type'
import { getWithDrawDepositGraph } from '../../services'

export default function useQueryGetWithDrawDepositGraph(
	payload: GetWithDrawDepositGraphRequest,
	props?: UseBaseQueryOptions<GetWithDrawDepositGraphResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.WithDrawDepositGraph, payload],
		queryFn: () => getWithDrawDepositGraph(payload),
		...props,
	})
}
